/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

const UsersContainerHeader = () => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__header-container'>
			<div className='table__users__item head'>
				<div className='table__users__item--col head'>
					{ dict.users.list.name.toUpperCase()}
				</div>
				<div className='table__users__item--col head'>
					{ dict.users.list.email.toUpperCase()}
				</div>
				<div className='table__users__item--col head'>
					{ dict.users.list.department.toUpperCase()}
				</div>
				<div className='table__users__item--col head'>
					{ dict.users.list.role.toUpperCase()}
				</div>
				<div className='table__users__item--col head'>
					{ dict.users.list.account.toUpperCase()}
				</div>
				<div className='table__users__item--col head' />
			</div>
		</div>
	);
};

export default memo(UsersContainerHeader);